import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LandingTemplate from "~/templates/LandingV2";
import { Translation } from "~/components/Translation";
var Landing = function() {
    return /*#__PURE__*/ _jsx(LandingTemplate, {
        heading: /*#__PURE__*/ _jsx(Translation, {
            tid: "landing.title"
        }),
        subHeading: /*#__PURE__*/ _jsx(Translation, {
            tid: "landing.subtitle.v2"
        })
    });
};
export default Landing;
